<template>
  <div
    :class="{
      'collapse': isMenuCollapsed,
      // 'hide-on-mobile-whitelabel': whitelabelEnabled
    }"
    class="user-details"
  >

    <!-- Account Settings Button -->
    <a
      v-on-clickaway="awaySettings"
      class="user-settings hidden-xs-only"
      :class="{ 'active': userSettingsVisible, 'collapse': isMenuCollapsed }"
      @click="toggleUserSettings"
    >
      <i class="ib-icon-tune text-silver h2 mr-3 text-white o-50" />
    </a>
    <!-- /Account Settings Button -->

    <!-- User Settings Menu -->
    <AccountSettings
      :class="{'collapse': isMenuCollapsed}"
      :user-settings-visible="userSettingsVisible"
      @change-billing="setDialogChangeBillingState(true)"
      @payment-history="setDialogPaymentHistoryState(true)"
      @logout="setDialogLogoutState(true)"
    />
    <!-- /User Settings Menu -->

    <!-- Logo -->
    <svg width="148" height="34" viewBox="0 0 148 34" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-if="!whitelabelEnabled" v-bind:class="'logo hidden-md-and-up'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><path id="a" d="M.113.123H6.29v6.185H.113z"/></defs><g fill="none" fill-rule="evenodd"><path d="M41.248 28.43V14.568a.86.86 0 01.86-.86h1.194a.86.86 0 01.86.86V28.43a.86.86 0 01-.86.86h-1.194a.86.86 0 01-.86-.86M48.28 23.792c0 1.915 1.38 3.228 3.114 3.228 1.712 0 3.18-1.247 3.18-3.228 0-1.914-1.468-3.206-3.18-3.206-1.735 0-3.113 1.225-3.113 3.206m9.183-9.202v13.84a.86.86 0 01-.86.86h-.91a.86.86 0 01-.854-.76l-.088-.753c-.845 1.314-2.202 1.759-3.536 1.759-3.224 0-5.648-2.137-5.648-5.744 0-3.785 2.38-5.743 5.581-5.743 1.157 0 2.958.623 3.603 1.758V14.59a.86.86 0 01.86-.86h.993a.86.86 0 01.86.86M67.358 22.523c-.178-1.425-1.29-2.137-2.846-2.137-1.468 0-2.669.712-3.07 2.137h5.916zm-5.96 2.249c.178 1.358 1.357 2.337 3.27 2.337.782 0 1.755-.231 2.44-.641a.845.845 0 011.022.139l.533.526a.865.865 0 01-.134 1.336c-1.125.748-2.585 1.111-3.906 1.111-3.78 0-6.026-2.337-6.026-5.855 0-3.339 2.268-5.743 5.826-5.743 3.435 0 5.662 1.991 5.584 5.955a.86.86 0 01-.86.835h-7.749zM73.583 23.792c0 2.093 1.445 3.34 3.246 3.34 4.27 0 4.27-6.657 0-6.657-1.8 0-3.246 1.224-3.246 3.317m7.392-5.476h.932a.86.86 0 01.86.86v9.254a.86.86 0 01-.86.86H81a.86.86 0 01-.856-.788l-.068-.814c-.623 1.291-2.335 1.915-3.558 1.937-3.246.022-5.648-1.982-5.648-5.833 0-3.785 2.513-5.766 5.715-5.743 1.467 0 2.868.69 3.49 1.78l.042-.703a.86.86 0 01.858-.81M87.33 26.553h4.491c1.2 0 2.913-.4 2.913-1.87 0-1.403-1.712-2.137-2.913-2.137h-4.492v4.007zm0-6.59h4.491c1.846 0 2.446-.779 2.446-1.67 0-.712-.578-1.914-2.446-1.914h-4.492v3.584zm9.85-1.737c0 1.203-.578 2.36-2.024 3.006 1.824.556 2.49 2.493 2.49 3.473 0 3.473-2.6 4.586-5.825 4.586h-6.523a.86.86 0 01-.86-.86V14.567a.86.86 0 01.86-.86h6.523c3.068 0 5.359 1.38 5.359 4.518zM100.741 18.316a.86.86 0 01.86.86v4.883c0 1.638.877 2.89 2.548 2.938 1.605.045 2.9-1.325 2.9-2.933v-4.887a.86.86 0 01.86-.861h.97a.86.86 0 01.86.86v9.277a.86.86 0 01-.86.86h-.8a.86.86 0 01-.854-.758l-.087-.733c-1.135 1.113-2.18 1.647-3.714 1.647-2.624 0-4.536-1.981-4.536-5.388v-4.904a.86.86 0 01.86-.861h.993zM113.596 23.792c0 1.915 1.378 3.228 3.113 3.228 1.712 0 3.18-1.247 3.18-3.228 0-1.914-1.468-3.206-3.18-3.206-1.735 0-3.113 1.225-3.113 3.206m9.183-9.202v13.84a.86.86 0 01-.86.86h-.91a.86.86 0 01-.854-.76l-.089-.753c-.845 1.314-2.201 1.759-3.535 1.759-3.224 0-5.648-2.137-5.648-5.744 0-3.785 2.379-5.743 5.581-5.743 1.156 0 2.958.623 3.602 1.758V14.59a.86.86 0 01.86-.86h.993a.86.86 0 01.86.86M126.613 23.792c0 1.915 1.379 3.228 3.113 3.228 1.712 0 3.18-1.247 3.18-3.228 0-1.914-1.468-3.206-3.18-3.206-1.734 0-3.113 1.225-3.113 3.206m9.184-9.202v13.84a.86.86 0 01-.86.86h-.91a.86.86 0 01-.855-.76l-.088-.753c-.845 1.314-2.201 1.759-3.536 1.759-3.224 0-5.648-2.137-5.648-5.744 0-3.785 2.38-5.743 5.582-5.743 1.156 0 2.957.623 3.602 1.758V14.59a.86.86 0 01.86-.86h.993a.86.86 0 01.86.86M147.888 19.517l-5.952 13.84a.86.86 0 01-.79.52h-1.108a.86.86 0 01-.79-1.2l1.53-3.564-3.9-9.612a.86.86 0 01.797-1.185h1.271c.365 0 .69.23.811.575l1.466 4.167 1.045 3.094 1.134-3.028 1.78-4.279a.86.86 0 01.794-.53h1.123a.86.86 0 01.79 1.202" fill="#FFF"/><g transform="translate(19.872 .026)"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M3.202 6.308A3.09 3.09 0 006.29 3.216 3.09 3.09 0 003.2.123 3.09 3.09 0 00.114 3.216a3.09 3.09 0 003.089 3.092" fill="#FFF" mask="url(#b)"/></g><path d="M26.423 13.321l2.987 5.18 2.967 5.144a22.218 22.218 0 000 0l2.59 4.49a.77.77 0 01-.667 1.156H.77a.77.77 0 01-.666-1.155l5.952-10.321 2.6-4.507a.766.766 0 011.271-.088 16.592 16.592 0 006.83 5.288l2.987-5.18 2.675-4.64a.769.769 0 011.333 0l2.671 4.633zm2.764 5.271zm-8.783.958z" fill="#FFF"/></g></svg>
    <!-- /Logo -->

    <!-- Avatar -->
    <div class="avatar-and-count hidden-sm-and-down">
      <!--      <img src="@/assets/img/logos/sidebar-header-logo.svg" class="sidebar-header-logo" alt="sidebar-header-logo">-->
      <!-- Logo -->
      <img
        v-if="!whitelabelEnabled"
        src="@/assets/img/logos/sidebar-header-logo.svg"
        class="sidebar-header-logo" alt="sidebar-header-logo"
        @click="disabled ? null : $router.push('/')"
      >
      <!-- /Logo -->

      <router-link :to="{name: 'account-settings-my-profile'}">
        <!-- Avatar Image -->
        <div v-if="userImage" class="avatar-uploader">
          <img
            :src="userImage"
            class="avatar"
            :class="{'collapse': isMenuCollapsed}"
            alt=""
          >
        </div>
        <!-- /Avatar Image -->

        <!-- Avatar Initials -->
        <div
          v-if="!userImage"
          class="avatar-placeholder"
          :class="{ 'man': userGender === 'male', 'woman': userGender === 'female', 'collapse': isMenuCollapsed }"
        >
          <div class="initials-wrapper">
            <p class="initials text-uppercase">
              {{ userInitials }}
            </p>
          </div>
        </div>
      <!-- /Avatar Initials -->
      </router-link>

    </div>
    <!-- /Avatar -->

    <!-- Name & Title -->
    <div
      class="user-name-title hidden-md-and-down"
      :class="{'collapse': isMenuCollapsed}"
    >
      <p class="name">
        {{ userFullName }}
      </p>
      <a class="link-with-pill-new">
        <!--Dreamer-->
        <template v-if="isRoleOwner">
          <span v-if="subscriptionIsFreeTrial">{{ $t('freeTrial.freeTrial') }}</span>
          <span v-else>{{ subscriptionPlanName }}</span>
        </template>
        <span v-if="isRoleGuest">{{ $t('userRoles.guest') }}</span>
        <span v-if="isRoleBuddy">{{ $t('userRoles.buddy') }}</span>
        <p v-if="isTemplateAdmin" class="template-manager">{{ $t('template.manager') }}</p>
      </a>
      <!-- TODO - Uncomment when implement pricing plans
      <a class="link-with-pill">Dreamer <span class="pill">Upgrade</span></a>
      -->
    </div>
    <!-- /Name & Title -->

    <!-- Idea Count -->
    <!--    <div class="idea-count hidden-md-and-down" :class="{'collapse': isMenuCollapsed}">-->
    <!--      <div class="star-wrapper">-->
    <!--        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.008 512.008" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M280.01 464.008h-48c-4.422 0-8 3.578-8 8v8c0 17.648 14.352 32 32 32s32-14.352 32-32v-8c0-4.422-3.578-8-8-8z" fill="#868491"/><path d="M256.002 464.008H232.01c-4.422 0-8 3.578-8 8v8c0 17.646 14.347 31.995 31.992 31.999v-47.999z" fill="#5c546a"/><path d="M381.983 49.895C344.592 14.754 295.616-2.847 244.249.375 150.639 6.2 75.014 84.286 72.092 178.149c-2.156 69.547 34.375 133.578 95.344 167.117 15.156 8.344 24.57 24.367 24.57 41.828v60.914c0 17.648 14.352 32 32 32h64c17.648 0 32-14.352 32-32v-60.914a47.87 47.87 0 0124.766-41.93c58.742-32.406 95.234-94.156 95.234-161.156 0-50.578-21.148-99.461-58.023-134.113z" fill="#ffcd00"/><circle cx="256.002" cy="184.008" r="128" fill="#ffe671"/><path d="M283.986 232.008c-10.633 0-16.07-6.203-20.031-10.727-3.492-3.984-4.883-5.273-8-5.273-3.102 0-4.484 1.289-7.961 5.266-3.734 4.273-9.383 10.734-20.016 10.734-10.625 0-16.273-6.461-20.008-10.734-3.477-3.977-4.859-5.266-7.961-5.266-4.422 0-8-3.578-8-8s3.578-8 8-8c10.625 0 16.273 6.461 20.008 10.734 3.477 3.977 4.859 5.266 7.961 5.266s4.492-1.289 7.969-5.266c3.734-4.273 9.383-10.734 20.008-10.734 10.633 0 16.07 6.203 20.031 10.727 3.492 3.984 4.883 5.273 8 5.273 3.109 0 4.5-1.289 7.992-5.266 3.742-4.273 9.391-10.734 20.031-10.734 4.422 0 8 3.578 8 8s-3.578 8-8 8c-3.117 0-4.508 1.289-8 5.273-3.742 4.274-9.39 10.727-20.023 10.727z" fill="#fff"/><path d="M232.002 384.008a8.012 8.012 0 01-7.813-6.297l-40-184c-.938-4.32 1.805-8.578 6.117-9.523 4.344-.953 8.578 1.805 9.523 6.117l40 184c.938 4.32-1.805 8.578-6.117 9.523a7.986 7.986 0 01-1.71.18zM280.017 384.008a8.06 8.06 0 01-1.711-.18c-4.313-.945-7.055-5.203-6.117-9.523l40-184a7.986 7.986 0 019.523-6.117c4.313.945 7.055 5.203 6.117 9.523l-40 184a8.008 8.008 0 01-7.812 6.297z" fill="#5c546a"/><path d="M190.633 376.008c.851 3.593 1.374 7.293 1.374 11.086v60.914c0 17.648 14.352 32 32 32h64c17.648 0 32-14.352 32-32v-60.914c0-3.79.527-7.491 1.384-11.086H190.633z" fill="#b4b6bc"/><path d="M256.002 376.008h-65.369c.851 3.593 1.374 7.293 1.374 11.086v60.914c0 17.648 14.352 32 32 32h31.995v-104zM256.002 400.008h64v16h-64zM256.006 432.008h64v16h-64z" fill="#868491"/><path fill="#5c546a" d="M192.002 400.008h64v16h-64zM192.002 432.008h64v16h-64z"/></svg>-->
    <!--      </div>-->
    <!--      <span-->
    <!--        class="text-regular"-->
    <!--        :class="{'large' : getIdeaText().length > 4}"-->
    <!--      >-->
    <!--        {{ ideasCount }}-->
    <!--        <span class="inner-text">-->
    <!--          {{ getIdeaText() }}-->
    <!--        </span>-->
    <!--      </span>-->
    <!--      <span class="text-on-hover" @click="() => $router.push({ name: 'idea-collection' })">{{ $t('collection') }}</span>-->
    <!--    </div>-->
    <!-- /Idea Count -->

    <!-- Arrow collapse/expand -->
    <main-sidebar-arrow v-if="!disabled" />
    <!-- /Arrow collapse/expand -->

    <main-sidebar-disabled-overlay v-if="disabled" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import AccountSettings from '@/views/Home/Components/MainSidebar/components/AccountSettings'
import MainSidebarArrow from '@/views/Home/Components/MainSidebar/components/MainSidebarArrow'
import MainSidebarDisabledOverlay from '@/views/Home/Components/MainSidebar/components/MainSidebarDisabledOverlay.vue'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import MixinUserSubscription from '@/mixins/permissions/userSubscription'
import { directive as onClickaway } from 'vue-clickaway'
import pluralize from 'pluralize'

import { getImageBySize } from '@/helpers/imageSizeHelper'

export default {
  name: 'MainSidebarHeader',

  directives: {
    onClickaway: onClickaway
  },
  components: {
    MainSidebarDisabledOverlay,
    MainSidebarArrow,
    AccountSettings
  },
  mixins: [
    MixinIdeaRoles,
    MixinUserSubscription
  ],

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      userSettingsVisible: false
    }
  },
  computed: {
    ...mapGetters('user', [
      'userInitials',
      'userFullName',
      'userGender',
      'userImage',
      'ideasCount',
      'images',
      'isTemplateAdmin',
      'subscriptionPlanName'
    ]),

    ...mapGetters('theme', ['isMenuCollapsed']),

    ...mapGetters('appSettings', ['whitelabelEnabled']),

    userImage () {
      return getImageBySize(this.images, 'medium')
    }
  },
  methods: {
    ...mapActions('user', [
      'getMyProfile'
    ]),

    ...mapMutations('ui', [
      'setDialogPaymentHistoryState',
      'setDialogLogoutState',
      'setDialogChangeBillingState'
    ]),

    toggleUserSettings () {
      if (this.disabled) return
      this.userSettingsVisible = !this.userSettingsVisible

      // if (this.userSettingsVisible) {
      //   this.getMyProfile()
      // }
    },

    getIdeaText () {
      return pluralize(this.$tc('idea'), this.ideasCount)
    },

    awaySettings () {
      this.userSettingsVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.template-manager {
  font-size: 12px;
  text-transform: uppercase;
}

.user-details {
  display: block;
  position: relative;
  text-align: center;
  background-color: var(--color-primary);
  padding: 14px;
  position: relative;

  &.collapse {
    //display: flex;
    //align-items: flex-end;
    //padding: 0;
    min-height: 85px;
    height: $ib-header-height;

    svg {
      width: 118px;
      margin: 0 0 10px 15px;
    }
  }

  @include media-breakpoint-down($md) {
    display: flex;
    align-items: flex-end;
    padding: 0;
    height: $ib-header-height;

    svg {
      width: 118px;
      margin: 0 0 10px 15px;
    }
  }

  @include media-breakpoint-between($md, $lg) {
    min-height: 95px;
  }

  &.hide-on-mobile-whitelabel {
    @include media-breakpoint-down($md) {
      display: none;
    }
  }

  .sidebar-header-logo {
    position: absolute;
    left: 0;
    top: 5px;
    width: 29px;
    opacity: .5;
    cursor: pointer;
    transition: all ease-in-out 0.25s;
    transform: scale(.9);

    &:hover {
      opacity: 1;
      transform: scale(1);
    }
    //::v-deep svg {
    //  path {
    //    fill: $color-text-light-gray;
    //  }
    //}
  }

  .user-settings {
    position: absolute;
    right: 14px;
    top: 14px;
    display: block;
    width: 24px;
    height: 30px;
    transform: scale(1);
    z-index: 10;

    &.collapse {
      bottom: 8px;
      top: unset;
      right: 22px;
    }

    @include media-breakpoint-between($md, $lg) {
      bottom: 12px;
      top: unset;
      right: 22px;
    }

    &:hover,
    &.active {
      transition: all ease-in-out 0.25s;
      transform: scale(1.2);

      i {
        opacity: 1;
      }
    }
  }

  .avatar-and-count {
    position: relative;
    width: 100%;
    height: 71px;

    @include media-breakpoint-between($md, $lg) {
      height: 100%;
    }
  }

  .avatar-uploader {

    &:hover {

      img {
        box-shadow: 5px 11px 20px 0 rgba(14, 14, 14, 0.33), 6px 0 6px 0 rgba(12, 11, 11, 0.28);
      }
    }

    img {
      width: 71px;
      height: 71px;
      box-shadow: 5px 11px 20px 0 rgba(14, 14, 14, 0.33), 6px 0 6px 0 rgba(12, 11, 11, 0.28);
      border: 2px solid #fff;
      background-color: #f3f4f5;

      @include media-breakpoint-between($md, $lg) {
        width: 50px;
        height: 50px;
        top: 25px;
      }

      &.collapse {
        width: 50px;
        height: 50px;
        top: 22px;
      }
    }
  }

  .avatar-placeholder {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    width: 71px;
    height: 71px;
    justify-content: center;
    align-items: center;
    border: 2px solid #ffffff;
    border-radius: 50%;
    background-color: #f5f6f6;
    background-size: 75%;
    background-position: center top 3px;
    background-repeat: no-repeat;
    box-shadow: 5px 11px 20px 0 rgba(14, 14, 14, 0.33), 6px 0 6px 0 rgba(12, 11, 11, 0.28);
    box-sizing: border-box;
    background-image: asset("img/icons/profile-icon.svg");

    &.collapse {
      width: 55px;
      height: 55px;
      top: -5px;
    }

    @include media-breakpoint-between($md, $lg) {
      width: 55px;
      height: 55px;
      top: -5px;
    }

    &.woman {
      background-image: asset("img/icons/woman-icon.svg");
    }

    &.man {
      background-image: asset("img/icons/man-icon.svg");
      background-position: center top 8px;
    }

    .initials-wrapper {
      .initials {
        font-family: outfit-semi-bold;
        color: $color-royal-blue;
        font-size: 22px;
        letter-spacing: 1.5px;
      }
    }
  }

  .idea-count {
    position: relative;
    display: flex;
    width: 100%;
    max-width: 82px;
    align-items: center;
    padding: 2px 8px 2px 22px;
    margin: 5px auto 0;
    color: $color-yellow;
    background-color: $color-white;
    border-radius: 9px;
    box-shadow: 0 7px 6px -7px rgba(41, 47, 77, 0.43);
    transition: all 0.25s;
    text-align: center;
    box-sizing: border-box;

    &.collapse {
      display: none;
    }

    &:hover {
      transition: all 0.25s;
      padding: 2px 16px;
      max-width: 100px;
      cursor: pointer;
      background-color: $color-yellow;
      color: $color-white;

      .text-regular {
        display: none;
      }

      .text-on-hover {
        display: block;
        font-family: outfit-semi-bold;
      }

      .star-wrapper {
        display: none;

        svg {
          path {
            fill: $color-yellow;
          }
        }
      }
    }

    .star-wrapper {
      position: absolute;
      top: 2px;
      left: 5px;
      display: block;
      line-height: 0;
      padding: 3px;
      margin-right: 3px;

      svg {
        width: 10px;
        height: auto;

        path {
          fill: $color-yellow;
        }
      }
    }

    .text-regular {
      display: inline-block;
      text-align: center;
      font-family: outfit-medium;
      font-size: 11px;
      text-transform: uppercase;
      position: relative;
      padding-right: 28px;
      margin: 0 auto;

      &.large {
        padding-right: 33px;
      }

      .inner-text {
        position: absolute;
        top: 0;
        right: 0;
      }
    }

    .text-on-hover {
      display: none;
      text-align: center;
      font-family: outfit-medium;
      font-size: 11px;
      text-transform: uppercase;
      overflow: hidden;
    }
  }

  .user-name-title {
    margin-top: 10px;

    &.collapse {
      display: none;
    }

    p {
      color: $color-white;
      margin: 0 auto;
    }

    .name {
      font-family: outfit-regular;
      font-size: 18px;
      line-height: 1.22;
    }

    .link-with-pill-new {
      font-family: outfit-regular;
      opacity: 0.5;
      font-size: 13px;
      transition: all 0.25s;
      color: $color-white;
      text-decoration: none;
      cursor: default;
    }

    .link-with-pill {
      font-family: outfit-regular;
      opacity: 0.5;
      font-size: 13px;
      transition: all 0.25s;
      color: $color-white;

      &:hover {
        transition: all 0.25s;
        cursor: pointer;
        opacity: 1;

        .pill {
          opacity: 1;
          right: unset;
          visibility: visible;
          left: 50%;
          transform: translateX(-50%);
          top: 0;
        }
      }

      .pill {
        opacity: 0;
        visibility: hidden;
        font-size: 10px;
        padding: 1px 5px;
        background-color: $color-mustard;
        right: unset;
        left: 50%;
        transform: translateX(-50%);
        top: 30px;
      }
    }
  }
}
</style>
